const borderColors = {
  RED: 'border-red-600',
  BLUE: 'border-rp-primary',
  DEFAULT: 'border-rp-gray-divider',
};

export default borderColors;
